import {type Widget} from '@dv5/domain'
import {CanvasPosition} from '../../model/CanvasPosition'
import {MousePosition} from '../../model/MousePosition'

export const getCanvasScale = (zoom: number): number => zoom >= 1 ? Math.floor(zoom) / 100 : 1

export const toCanvasPosition = (
    position: MousePosition,
    viewportRect: Pick<DOMRect, 'left' | 'top'>,
    zoom: number,
    scrollPosition: CanvasPosition,
): CanvasPosition => ({
    left: (position.x - viewportRect.left) / getCanvasScale(zoom) + scrollPosition.left,
    top: (position.y - viewportRect.top) / getCanvasScale(zoom) + scrollPosition.top,
})

export const getCanvasWheelDelta = (
    event: Pick<WheelEvent, 'deltaX' | 'deltaY' | 'deltaMode' | 'shiftKey'>,
    viewport: {width: number, height: number},
    zoom: number,
): CanvasPosition => {
    // Browsers may already remap Shift + wheel to deltaX.
    const horizontalOnly = event.shiftKey && event.deltaX === 0
    const x = horizontalOnly ? event.deltaY : event.deltaX
    const y = horizontalOnly ? 0 : event.deltaY
    const unitX = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? viewport.width : 1
    const unitY = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? viewport.height : 1
    return {left: x * unitX / getCanvasScale(zoom), top: y * unitY / getCanvasScale(zoom)}
}

// Scroll position that centers a widget rectangle inside the viewport.
// Viewport dimensions are screen pixels; widget geometry is canvas units.
export const computeRevealScrollPosition = (
    widget: Pick<Widget, 'left' | 'top' | 'width' | 'height'>,
    viewport: {width: number, height: number},
    zoom: number,
): CanvasPosition => {
    const scale = getCanvasScale(zoom)
    return {
        left: widget.left + widget.width / 2 - viewport.width / scale / 2,
        top: widget.top + widget.height / 2 - viewport.height / scale / 2,
    }
}
